// extracted by mini-css-extract-plugin
export default {"spinner":"LoaderElementDark_spinner__uxb0p"};